window.o_global = window.o_global || {};
window.o_util = window.o_util || {};

/**
 * Utility collection of miscellaneous functions.
 *
 * @return {Object} Public methods of o_util.misc.
 */
o_util.misc = (function(w) {
    "use strict";

    /**
     * Reads the pagecluster information from html-data-attribute.
     */
    function getPagecluster() {
        return document.documentElement.getAttribute("data-pagecluster");
    }

    /**
     * Returns true if responsive-preview cookie exists with value true, false otherwise.
     *
     * @example o_util.misc.isResponsive();
     *
     * @return {Boolean} Is responsive-preview cookie set and true?
     */
    function isResponsive() {
        return o_util.cookie.get("responsive-preview") === "true";
    }

    /**
     * Determine if the mouse button you expected to be clicked was actually clicked.
     * Initially implemented due to event handling bug in firefox.
     *
     * @example
     * // Check if the left mouse button was clicked.
     * o_util.misc.isValidMouseButton(event, 1);
     *
     * @param {Object} event    Received event object.
     * @param {Number} key      MouseButton Code. For further details see:
     *                          https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/which
     *                          https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/button
     *
     * @return {Boolean} Was the mouse button the one you expected?
     */
    function isValidMouseButton(event, key) {
        if ("which" in event) {
            return event.which === key;
        }

        return true;
    }

    /**
     * Set vendor prefixed style of an element.
     *
     * @example
     * // This will set the transform property via javascript - additional to the original style - with webkit, Moz, ms and O prefix.
     * o_util.misc.setVendorStyle(modalContainer, "transform", "translateY(0)");
     *
     * @param {Object} element      The DOM element that will be styled.
     * @param {String} property     The CSS property.
     * @param {String} value        The property"s value.
     */
    function setVendorStyle(element, property, value) {
        // Automatically uppercase the first letter of the property.
        var prefixProperty = property.charAt(0).toUpperCase() + property.slice(1);

        element.style["webkit" + prefixProperty] = value;
        element.style["Moz" + prefixProperty] = value;
        element.style["ms" + prefixProperty] = value;
        element.style["O" + prefixProperty] = value;
        element.style[property] = value;
    }

    /**
     * Generates a very unique string (Globally Unique Identifier)
     *
     * @return {String}     Very unique string (Globally Unique Identifier)
     */
    function guid() {
        /**
         * Generates a random number.
         *
         * @return {String}     Random number.
         */
        function s4() {
            return Math.floor((1 + Math.random()) * 0x10000)
                .toString(16)
                .substring(1);
        }

        return s4() + s4() + "-" + s4() + "-" + s4() + "-" +
            s4() + "-" + s4() + s4() + s4();
    }

    /**
     * Convert an url string to an actual HTMLAnchorElement.
     * Hint: All versions of Internet Explorer omit the leading slash in pathname property!
     *
     * @param {String} urlString     Url string which must contain
     *
     * @return {HTMLAnchorElement} Anchor element which contains information about pathname,
     */
    function urlToLinkObject(urlString) {
        var anchorElement = document.createElement("a");

        anchorElement.href = urlString;

        return anchorElement;
    }

    /**
     * @param {string} urlString     Url string.
     *
     * @return {boolean} true, when on preview,
     */
    function isPreview(urlString) {
        if (typeof urlString !== "string") {
            o_global.debug.warn("o_util.misc.isPreview() parameter is no string");

            return false;
        }

        return urlString.indexOf("/shoppages/preview") !== -1;
    }

    /**
     * Return public API.
     */
    return {
        "getPagecluster": getPagecluster,
        "isResponsive": isResponsive,
        "isValidMouseButton": isValidMouseButton,
        "setVendorStyle": setVendorStyle,
        "guid": guid,
        "urlToLinkObject": urlToLinkObject,
        "isPreview": isPreview
    };
}(window));

// Namespace fallbacks.
o_global.helper = o_global.helper || {};
o_global.helper.isResponsive = o_util.misc.isResponsive;
o_global.helper.isValidMouseButton = o_util.misc.isValidMouseButton;
o_global.helper.setVendorStyle = o_util.misc.setVendorStyle;
